import { useScopedAtomValue } from '@lemon8/webapp-shared/component';
import { FC } from 'react';
import { $CurrentGalleryArticle } from '~/components/article-gallery/atoms';
import { WarningLabel } from '~/components/warning-label';

export const WarningLabelSection: FC = () => {
  const article = useScopedAtomValue($CurrentGalleryArticle);

  return <WarningLabel illegalInfo={article.illegalInfo} />;
};
